import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'

export const StyledProductHighlight = styled.div`
  flex-direction: Column;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;

  @media ${deviceMax.mobileL} {
    gap: ${pxToRem(20)};
  }
`
export const StyledBlockText = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: ${pxToRem(1198)};
`
export const StyledColoredContainer = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
  background-color: ${({ theme, $isPair }) =>
    $isPair ? theme.colors.secondary.grey90 : theme.colors.unique.white};

  @media ${deviceMax.laptop} {
    padding: 0 ${pxToRem(10)};
  }

  @media ${deviceMax.mobileL} {
    background-color: ${({ theme }) => theme.colors.secondary.grey90};
    height: fit-content;
  }
`
